












































import ProductItem from '@/components/ProductItem.vue'
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'
import { ExitWithCategoryEventData, ExitWithProductEventData } from '@/services/Statistic/PostData'
import searcherry from '@/services/Searcherry/Searcherry'

@Component({
  name: 'all-results',
  components: { ProductItem }
})
export default class AllResults extends Vue {
  @Prop() searchResults: any
  @PropSync('searchPhraseProp', { type: String }) searchPhrase!: string

  srchrryTrnCategory = ''
  isAnimationEnabled = searcherryConfig.isAnimationEnabled

  created () {
    this.srchrryTrnCategory = this.isAnimationEnabled ? 'srchrry-trn-category' : ''
  }

  clickCategory (category: any) {
    let data = new ExitWithCategoryEventData()
    data.categoryName = category.name
    data.categoryUrl = category.url
    data.searchPhrase = this.$route.params.searchPhrase
    searcherry.statisticService.exitWithCategoryEvent(data)
    searcherry.generateEvent('exit-category')
  }
}
